import { detectFaceBounds, type NormalizedRect } from './imageContentBounds'

/** 角色卡竖版取景：仅浏览器 FaceDetector（Chrome/Edge）；无脸或未支持则返回 null */
export async function analyzePortraitFocusBounds(
  image: HTMLImageElement,
): Promise<NormalizedRect | null> {
  const face = await detectFaceBounds(image)
  if (!face || (face.w >= 0.98 && face.h >= 0.98)) {
    return null
  }
  return face
}
